<div class="mainContainer">
    <div class="filter_show division-report-toolbar">
        <button type="button" class="division-report-back" (click)="goBack()"><i class="fa fa-angle-left icon-left" aria-hidden="true"></i> Back</button>
        <h2 class="log_track division-report-title">{{ divisionName || 'Division Report' }}</h2>
    </div>

    <div class="mess-box">
        <div class="division-summary-pills">
            <div class="division-summary-pills__left">
                <span class="division-summary-pill division-summary-pill--closed">
                    Closed : {{ summary.closed }} ({{ summaryPercent(summary.closed) }})
                </span>
                <span class="division-summary-pill division-summary-pill--pending">
                    Pending : {{ summary.pending }} ({{ summaryPercent(summary.pending) }})
                </span>
                <span class="division-summary-pill division-summary-pill--holiday">
                    Holiday : {{ summary.holiday }} ({{ summaryPercent(summary.holiday) }})
                </span>
                <span class="division-summary-pill division-summary-pill--not-submitted">
                    Not Submitted : {{ summary.notSubmitted }} ({{ summaryPercent(summary.notSubmitted) }})
                </span>
            </div>
            <span class="division-summary-pill division-summary-pill--total">
                Total Kitchens : {{ kitchensCount }}
            </span>
        </div>

        <div class="month-legend">
            <span class="month-legend__item">
                <span class="month-legend__swatch month-legend__swatch--closed"></span> Submitted & Approved

            </span>
            <span class="month-legend__item">
                <span class="month-legend__swatch month-legend__swatch--pending"></span> Pending Approval
            </span>
            <span class="month-legend__item">
                <span class="month-legend__swatch month-legend__swatch--holiday"></span> Not Applicable / Holiday
            </span>
            <span class="month-legend__item">
                <span class="month-legend__swatch month-legend__swatch--not-submitted"></span> Not Submitted
            </span>
          
        </div>


        <div class="division-kitchen-grid-wrap" *ngIf="kitchens.length; else noKitchens">
            <div class="division-kitchen-grid">
                <div class="division-kitchen-grid__section division-kitchen-grid__section--kitchens">
                    <div class="division-kitchen-grid__section-title">Kitchens</div>
                    <div class="division-kitchen-grid__kitchen-header" [style.height.px]="kitchenHeaderHeight">
                        Kitchens
                    </div>
                    <div class="division-kitchen-row division-kitchen-row--kitchen"
                        *ngFor="let kitchen of kitchens; trackBy: trackKitchen; let rowIndex = index"
                        [style.height.px]="getKitchenRowHeight(rowIndex)"
                        [style.minHeight.px]="getKitchenRowHeight(rowIndex)"
                        [style.maxHeight.px]="getKitchenRowHeight(rowIndex)"
                        [class.division-kitchen-row--active]="hoveredKitchenId === kitchen.messBuildingId"
                        (mouseenter)="onKitchenRowEnter(kitchen)"
                        (mouseleave)="onKitchenRowLeave()">
                        <div class="division-kitchen-row__entity">{{ kitchen.entityName }}</div>
                        <div class="division-kitchen-row__building">{{ kitchen.messBuildingName }}</div>

                        <div class="kitchen-summary-popover" *ngIf="hoveredKitchenId === kitchen.messBuildingId">
                            <div class="kitchen-summary-popover__row kitchen-summary-popover__row--closed">
                                <span>Closed</span>
                                <span>{{ kitchen.summary.closed }} ({{ kitchenSummaryPercent(kitchen, kitchen.summary.closed) }})</span>
                            </div>
                            <div class="kitchen-summary-popover__row kitchen-summary-popover__row--pending">
                                <span>Pending</span>
                                <span>{{ kitchen.summary.pending }} ({{ kitchenSummaryPercent(kitchen, kitchen.summary.pending) }})</span>
                            </div>
                            <div class="kitchen-summary-popover__row kitchen-summary-popover__row--holiday">
                                <span>Holiday</span>
                                <span>{{ kitchen.summary.holiday }} ({{ kitchenSummaryPercent(kitchen, kitchen.summary.holiday) }})</span>
                            </div>
                            <div class="kitchen-summary-popover__row kitchen-summary-popover__row--not-submitted">
                                <span>Not Submitted</span>
                                <span>{{ kitchen.summary.notSubmitted }} ({{ kitchenSummaryPercent(kitchen, kitchen.summary.notSubmitted) }})</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="division-kitchen-grid__section division-kitchen-grid__section--days">
                    <div class="division-kitchen-grid__section-title">{{ monthLabel }}</div>
                    <div class="division-monthly-grid-wrap monthly-grid-wrap monthly-grid-wrap--active">
                        <ag-grid-angular
                            style="width: 100%;"
                            [rowData]="rowData"
                            [columnDefs]="monthlyColDefs"
                            [defaultColDef]="divisionDefaultColDef"
                            [gridOptions]="divisionGridOptions"
                            [rowHeight]="kitchenRowHeight"
                            [headerHeight]="kitchenHeaderHeight"
                            [overlayNoRowsTemplate]="overlayNoRowsTemplate"
                            (gridReady)="onGridReady($event)"
                            (firstDataRendered)="onFirstDataRendered()"
                            (cellClicked)="onCellClicked($event)" />
                    </div>
                </div>
            </div>
        </div>

        <ng-template #noKitchens>
            <div class="division-kitchen-empty">No kitchen data found for this division.</div>
        </ng-template>

       
    </div>
</div>

<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>
